import { render, staticRenderFns } from "./FormularioLandingView.vue?vue&type=template&id=47cea742&"
import script from "./FormularioLandingView.vue?vue&type=script&lang=ts&"
export * from "./FormularioLandingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports